/**
 * Converts a flat list to hierarchical.
 *
 * @param data The data items as an array.
 * @param param1 The data item property keys.
 * @returns Data Array
 */
export function flatListToHierarchical(data = [], { idKey = 'id', parentKey = 'parentId', childrenKey = 'children', } = {}) {
    const tree = [];
    const childrenOf = {};
    data.forEach((item) => {
        var _a;
        const newItem = Object.assign({}, item);
        const id = newItem === null || newItem === void 0 ? void 0 : newItem[idKey];
        const parentId = ((_a = newItem === null || newItem === void 0 ? void 0 : newItem[parentKey]) !== null && _a !== void 0 ? _a : 0);
        if (!id) {
            return;
        }
        childrenOf[id] = childrenOf[id] || [];
        newItem[childrenKey] = childrenOf[id];
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        parentId
            ? (childrenOf[parentId] = childrenOf[parentId] || []).push(newItem)
            : tree.push(newItem);
    });
    return tree;
}
